export const BLOG_ROOT = 'blog';

export function getPageUrlFromSlug(slug: string): string {
  return `${BLOG_ROOT}/${slug}`;
}

export function getPageUrl(entry: BlogPage): string {
  return getPageUrlFromSlug(entry.slug);
}

export function getListUrl(name, value): string {
  return `${BLOG_ROOT}/${name}/${value}`;
}

export enum ListType {
  CATEGORY = 'category',
  TAG = 'tag',
}

export interface BlogCategory {
  id: number;
  name: string;
  slug: string;
}

interface BlogImage {
  url: string;
  width: number;
  height: number;
}

export class BlogPage {
  id: number;
  title: string;
  thumbnail: BlogImage;
  categories: BlogCategory[];
  date: string;
  intro_html: string;
  body_html?: string;
  tags?: string[];
  slug?: string;
  meta?: any;

  date_obj: Date;
  url: string;

  private blogService;

  setBlogService(blogService): BlogPage {
    this.blogService = blogService;
    return this;
  }

  deserialize(data: any): BlogPage {
    Object.assign(this, data);
    if (this.meta) {
      const slug = this.meta['slug'];
      if (slug) {
        this.slug = slug;
      }
      // const categories = this.meta['categories'];
      // if (categories) {
      //   this.categories = categories;
      // }
    }
    if (this.slug) {
      this.url = `/${BLOG_ROOT}/${this.slug}`;
    }
    if (this.date) {
      this.date_obj = new Date(this.date);
    }
    return this;
  }

}

export interface BlogIndexPage {
  title: string;
  intro_html: string;
  items: BlogPage[];
  news: BlogNewsItem[];
}

export interface NewsletterSubscription {
  user: number;
  email: string;
  confirmed: boolean;
  unsubscribed: boolean;
}

export interface NewsletterConfirmData {
  id: number;
  confirmed: boolean;
  sign: string;
}

export interface NewsletterCancelData {
  id: number;
  unsubscribed: boolean;
  sign: string;
}

export interface BlogNewsItem {
  id: number;
  title: string;
  content: string;
  date: string;
  thumbnail: BlogImage;
}
